import {
  CheckoutSession,
  getCheckoutSessionAvailablePaymentMethodTypesById,
  PaymentMethodType,
} from '@nemuru-eng/js-api-client';
import { useMemo, useState } from 'react';

import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { useErrorBoundary } from '@/components/shared/components/ErrorBoundary/hooks/useErrorBoundary';

export const useGetNewAvailablePaymentMethods = (
  checkoutSession: CheckoutSession,
  paymentMethodDetailEntities: PaymentMethodDetailEntity[],
) => {
  const { throwErrorInDialog } = useErrorBoundary();

  const [loading, setLoading] = useState<boolean>(false);
  const [newAvailablePaymentMethods, setNewAvailablePaymentMethods] = useState<PaymentMethodType[] | null>();

  const getNewAvailablePaymentMethods = async (amount: number | undefined) => {
    if (!checkoutSession || !amount) {
      return;
    }

    setLoading(true);

    try {
      const availablePaymentMethods = await getCheckoutSessionAvailablePaymentMethodTypesById({
        checkoutSessionId: checkoutSession.id,
        amount,
      });
      setNewAvailablePaymentMethods(availablePaymentMethods);
    } catch (error) {
      throwErrorInDialog(error);
    } finally {
      setLoading(false);
    }
  };

  const hasChangesInAvailablePaymentMethods = useMemo<null | boolean>(() => {
    if (!newAvailablePaymentMethods || !paymentMethodDetailEntities) {
      return null;
    }

    return paymentMethodDetailEntities.some(
      (paymentMethodDetailEntity) => !newAvailablePaymentMethods.includes(paymentMethodDetailEntity.type),
    );
  }, [newAvailablePaymentMethods, paymentMethodDetailEntities]);

  return {
    getNewAvailablePaymentMethods,
    setNewAvailablePaymentMethods,
    newAvailablePaymentMethods,
    loadingGetNewAvailablePaymentMethods: loading,
    hasChangesInAvailablePaymentMethods,
  };
};
